import { ISuggestRosreestrDataRequest } from '../../../../repositories/countryside-rosreestr/v1/suggest-rosreestr-data';
import { IGetRosreestrDataParams } from '../../../../services/rosreestrData';
import { ECadastralFieldsNames, IRosreestrDataState } from '../../../../types/reducers/rosreestrData';
import { IOfferState } from '../../../../redux/reducers';
import { hasError } from './hasError';

export const getParameters = (
  fields: Pick<IOfferState, ECadastralFieldsNames>,
  meta: IRosreestrDataState['cadastralFieldsMeta'],
): ISuggestRosreestrDataRequest => {
  const { buildingCadastralNumber, cadastralNumber } = fields;
  const parameters = {} as IGetRosreestrDataParams['parameters'];

  if (buildingCadastralNumber && !hasError(meta.buildingCadastralNumber.errors, buildingCadastralNumber)) {
    parameters.buildingCadastralNumber = buildingCadastralNumber;
  }

  if (cadastralNumber && !hasError(meta.cadastralNumber.errors, cadastralNumber)) {
    parameters.cadastralNumber = cadastralNumber;
  }

  return parameters;
};
